import React from "react";
import { withAuth, withSSO } from "../hoc";
import MainLayout from "../layout";
import AuthLayout from "../layout/AuthLayout";
import RaiseComplaint from "app/pages/raise-complaint/RaiseComplaints";
import PaymentGateway from "app/pages/payment-gateway/PaymentGateway";
import Pay from "app/pages/Pay/Pay";
import Viewall from "app/pages/view-all/Viewall";
import Subscription from "app/pages/subscription/Subscription";
import MobileRecharge from "app/pages/mobile-recharge/MobileRecharge";
import Electricity from "app/pages/electricity/Electricity";
import ForgotPassword from "app/pages/auth/ForgotPassword";
import ResetPassword from "app/pages/auth/ResetPassword";
import CircleOperatorByNumber from "app/pages/mobile-recharge/CircleOperatorByNumber";
import RechargePlanByCircleOperator from "app/pages/mobile-recharge/RechargePlanByCircleOperator";
import RechargePlanDetailsById from "app/pages/mobile-recharge/RechargePlanDetailsById";
import ComplaintDetails from "app/components/complaint/ComplaintDetails";

const EditBill = React.lazy(() => import("app/pages/edit-bill/EditBill"));
const ListingPage = React.lazy(() =>
  import("app/components/listview/ListingPage"),
);
const ReminderById = React.lazy(() =>
  import("app/pages/reminder-by-id/ReminderById"),
);
const MultipleBillPayments = React.lazy(() =>
  import("app/components/multipleBillPayments/MultipleBillPayments"),
);
const InsuranceBillDetails = React.lazy(() =>
  import("app/components/insurance-bill-details/InsuranceBillDetails"),
);
const Insurance = React.lazy(() => import("app/pages/insurance/Insurance"));
const Notifications = React.lazy(() =>
  import("app/pages/notifications/Notifications"),
);
const Profile = React.lazy(() => import("app/pages/profile/Profile"));
const RemindersLists = React.lazy(() =>
  import("app/pages/reminder-by-id/RemindersLists"),
);
const AutopayLists = React.lazy(() =>
  import("app/pages/autopaylists/AutopayLists"),
);
const TransactionSuccess = React.lazy(() =>
  import("app/components/transationscard/TransactionSuccess"),
);
const TransactionFailure = React.lazy(() =>
  import("app/components/transationscard/TransactionFailure"),
);
const TransactionCancel = React.lazy(() =>
  import("app/components/transationscard/TransactionCancel"),
);
const Home = React.lazy(() => import("app/pages/Home"));
const MyBills = React.lazy(() => import("app/pages/my-bills/Mybills"));
const AllBillerCategoriesLists = React.lazy(() =>
  import("app/pages/biller-categories/AllBillerCategoriesLists"),
);
const BillerCategories = React.lazy(() =>
  import("app/pages/biller-categories/BillerCategories"),
);
const BillerListByCategory = React.lazy(() =>
  import("app/pages/biller-categories/BillerListByCategory"),
);
const BillerDetailsById = React.lazy(() =>
  import("app/pages/biller-categories/BillerDetailsById"),
);
const BillDetailsById = React.lazy(() =>
  import("app/pages/biller-categories/BillDetailsById"),
);
const MyBillDetailsById = React.lazy(() =>
  import("app/pages/Bill-detail-page/MyBillDetailsById"),
);
const Help = React.lazy(() => import("app/pages/help/Help"));
const History = React.lazy(() => import("app/pages/history/History"));
const TransactionDetailsById = React.lazy(() =>
  import("app/components/transaction-details/TransactionDetailsById"),
);
const SpendAnalyis = React.lazy(() =>
  import("app/pages/spend-analyis/SpendAnalyis"),
);
const BillsByCategoyId = React.lazy(() =>
  import("app/pages/bills-by-categoy/BillsByCategoyId"),
);
const Login = React.lazy(() => import("app/pages/auth/Login"));
const SignUp = React.lazy(() => import("app/pages/auth/SignUp"));
const Panel = React.lazy(() => import("app/pages/panel/Panel"));
const NotFoundPage = React.lazy(() =>
  import("app/pages/Error404/NotFoundPage"),
);
const TransactionDetail = React.lazy(() => import("app/pages/txn/details"));
// const ComplaintDetails = React.lazy(()=> import("app/components/complaint/ComplaintDetails"));

const routes = [
  {
    path: "/auth",
    component: withSSO(AuthLayout),
    routes: [
      {
        path: "/auth",
        exact: true,
        component: Login,
        key: "login-default",
      },
      {
        path: "/auth/login",
        exact: true,
        component: Login,
        key: "login",
      },
      {
        path: "/auth/sign-up",
        exact: true,
        component: SignUp,
        key: "sign-up",
      },
      {
        path: "/auth/forgotpassword",
        exact: true,
        component: ForgotPassword,
        key: "forgot-password",
      },
      {
        path: "/auth/resetpassword",
        exact: true,
        component: ResetPassword,
        key: "reset-password",
      },
      {
        path: "*",
        component: NotFoundPage,
        key: "not-found",
      },
    ],
  },
  {
    path: "/cmsRequest/:id",
    exact: true,
    component: TransactionDetail,
    key: "txn-detail",
  },
  {
    path: "/",
    component: withAuth(MainLayout),
    routes: [
      {
        path: "/",
        exact: true,
        component: Home,
        key: "home-default",
      },
      {
        path: "/home",
        exact: true,
        component: Home,
        key: "home",
      },
      {
        path: "/my-bills",
        exact: true,
        component: MyBills,
        key: "my-bills",
      },
      {
        path: "/biller-categories",
        exact: true,
        component: AllBillerCategoriesLists,
        key: "all-biller-categories",
      },
      {
        path: "/transaction",
        exact: true,
        component: Panel,
        key: "transaction",
      },
      {
        path: "/biller-categories/:id",
        exact: true,
        component: BillerCategories,
        key: "biller-categories",
      },
      {
        path: "/biller-list/:id",
        exact: true,
        component: BillerListByCategory,
        key: "biller-list-by-categories-name",
      },
      {
        path: "/biller/:id",
        exact: true,
        component: BillerDetailsById,
        key: "biller-details-by-biller-id",
      },
      {
        path: "/bill/:id",
        exact: true,
        component: BillDetailsById,
        key: "bill-details-by-biller-id",
      },
      {
        path: "/bill-details/:id",
        exact: true,
        component: MyBillDetailsById,
        key: "my-bill-details-by-biller-id",
      },
      {
        path: "/edit-bill/:id",
        exact: true,
        component: EditBill,
        key: "edit-bill-by-id",
      },
      {
        path: "/raise-complaint",
        exact: true,
        component: RaiseComplaint,
        key: "raise-complaint",
      },
      {
        path: "/help",
        exact: true,
        component: Help,
        key: "help",
      },
      {
        path: "/spend-analysis",
        exact: true,
        component: SpendAnalyis,
        key: "spend-analyis",
      },
      {
        path: "/:name/bill/:id",
        exact: true,
        component: BillsByCategoyId,
        key: "bills-by-categoy-id",
      },
      {
        path: "/history",
        exact: true,
        component: History,
        key: "history",
      },
      {
        path: "/transaction/:id",
        exact: true,
        component: TransactionDetailsById,
        key: "transaction-details-by-id",
      },
      {
        path: "/complaintDetails/:id",
        component: ComplaintDetails,
        exact: true,
        key: "complaint-details-by-id"
      },
      {
        path: "/payment-gateway",
        exact: true,
        component: PaymentGateway,
        key: "payment-gateway",
      },
      {
        path: "/pay",
        exact: true,
        component: Pay,
        key: "pay",
      },
      {
        path: "/transactionCompleted",
        exact: true,
        component: TransactionSuccess,
        key: "transactionSuccess",
      },
      {
        path: "/transactionFailure",
        exact: true,
        component: TransactionFailure,
        key: "transactionFailure",
      },
      {
        path: "/transactionCancel",
        exact: true,
        component: TransactionCancel,
        key: "transactionFailure",
      },
      {
        path: "/autopaylists",
        exact: true,
        component: AutopayLists,
        key: "autopaylists",
      },
      {
        path: "/reminders-lists",
        exact: true,
        component: RemindersLists,
        key: "reminders-lists",
      },
      {
        path: "/reminder/:id",
        exact: true,
        component: ReminderById,
        key: "reminder-by-id",
      },
      {
        path: "/notifications",
        exact: true,
        component: Notifications,
        key: "notifications",
      },
      {
        path: "/profile",
        exact: true,
        component: Profile,
        key: "profile",
      },
      {
        path: "/view-all",
        exact: true,
        component: Viewall,
        key: "view-all",
      },
      {
        path: "/subscription",
        exact: true,
        component: Subscription,
        key: "subscription",
      },
      {
        path: "/recharge/:category",
        exact: true,
        component: MobileRecharge,
        key: "mobile-recharge",
      },
      {
        path: "/recharge/mobile/:number",
        exact: true,
        component: CircleOperatorByNumber,
        key: "circle-operator-by-number",
      },
      {
        path: "/recharge/:operator/:circle/plan",
        exact: true,
        component: RechargePlanByCircleOperator,
        key: "recharge-plan-by-circle-operator",
      },
      {
        path: "/mobile-recharge/browse-plans/:id",
        exact: true,
        component: RechargePlanDetailsById,
        key: "recharge-plan-details-by-id",
      },
      {
        path: "/electricity",
        exact: true,
        component: Electricity,
        key: "electricity",
      },
      {
        path: "/insurance",
        exact: true,
        component: Insurance,
        key: "insurance",
      },
      {
        path: "/insurancebilldetails",
        exact: true,
        component: InsuranceBillDetails,
        key: "insurancebilldetails",
      },
      {
        path: "/multipleBillpayments",
        exact: true,
        component: MultipleBillPayments,
        key: "multipleBillpayments",
      },
      {
        path: "/listingpage",
        exact: true,
        component: ListingPage,
        key: "listingpage",
      },
      {
        path: "*",
        component: NotFoundPage,
        key: "not-found",
      },
    ],
  },

];

/**
 * Generate Route
 * @param {string} key route key
 * @param {array} routes routes array
 * @returns {string} url
 */

const generateRoute = (key, mainRoutes = routes) => {
  let url = false;
  mainRoutes.some((i) => {
    if (i.key === key && !url) {
      url = i.path;
    } else if (i.routes) {
      url = generateRoute(key, i.routes);
    }
    return url;
  });
  return url;
};

export { routes, generateRoute };
